export function generateCacheTag(...params: (string | number)[]) {
  const stringParams = params.map((p) => p.toString());

  if (stringParams.length === 1) return stringParams;

  return [...params.map((s) => s.toString()), params.join(":")];
}
